"use strict";

import angular from "angular";

angular.module("nucont.accounting.group").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider
        .state("nucont.accounting.group.monitoring.audit", {
            url: "/auditoria",
            views: {
                "tableContent@nucont.accounting.group.monitoring": {
                    component: "monitoringCompanyAuditComponent",
                    bindings: { companyData: "groupData" }
                }
            }
        })
        .state("nucont.accounting.group.monitoring.audit.showtime", {
            url: "/showtime"
        })
        .state(
            "nucont.accounting.group.monitoring.audit.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.monitoring.audit": {
                        component: "indicatorDescriptionComponent"
                    }
                }
            }
        )
        .state("nucont.accounting.group.monitoring.audit.showtime.comments", {
            url: "/comentarios",
            views: {
                "subModule@nucont.accounting.group.monitoring.audit": {
                    component: "indicatorCommentsComponent",
                    bindings: { companyData: "groupData" }
                }
            }
        })
        .state("nucont.accounting.group.monitoring.audit.showtime.insights", {
            url: "/insights",
            views: {
                "subModule@nucont.accounting.group.monitoring.audit": {
                    component: "indicatorInsightsComponent"
                }
            }
        })
        .state("nucont.accounting.group.monitoring.health", {
            url: "/objetivos",
            views: {
                "tableContent@nucont.accounting.group.monitoring": {
                    component: "goalsCompanyComponent",
                    bindings: { companyData: "groupData" }
                }
            }
        })
        .state("nucont.accounting.group.monitoring.health.showtime", {
            url: "/showtime"
        })
        .state(
            "nucont.accounting.group.monitoring.health.showtime.description",
            {
                url: "/descricao",
                views: {
                    "subModule@nucont.accounting.group.monitoring.health": {
                        component: "indicatorDescriptionComponent"
                    }
                }
            }
        )
        .state("nucont.accounting.group.monitoring.health.showtime.comments", {
            url: "/comentarios",
            views: {
                "subModule@nucont.accounting.group.monitoring.health": {
                    component: "indicatorCommentsComponent",
                    bindings: { companyData: "groupData" }
                }
            }
        })
        .state("nucont.accounting.group.monitoring.health.showtime.insights", {
            url: "/insights",
            views: {
                "subModule@nucont.accounting.group.monitoring.health": {
                    component: "indicatorInsightsComponent"
                }
            }
        });
}
